import React from "react"

import Header from "../components/Header"
import Navigation from "../components/Navigation"
import User from "../components/admin/user/User"

function AdminUserPage() {
  return (
    <>
      <Header />
      <div className="page-with-nav">
        <Navigation />
        <User />
      </div>
    </>
  )
}

export default AdminUserPage
